import { render, staticRenderFns } from "./PanelStud.vue?vue&type=template&id=71fc8adc&scoped=true&"
import script from "./PanelStud.vue?vue&type=script&lang=js&"
export * from "./PanelStud.vue?vue&type=script&lang=js&"
import style0 from "./PanelStud.vue?vue&type=style&index=0&id=71fc8adc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc8adc",
  null
  
)

export default component.exports